import { motion } from 'framer-motion';
import { Phone, Mail, MapPin } from 'lucide-react';
import { contactData } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h3 className="text-3xl font-bold mb-4 bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">
              ADL Cleaning Services
            </h3>
            <p className="text-white/60 leading-relaxed">
              Delivering reliable, detailed cleaning for homes and businesses across the region since 2004.
            </p>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-white/60 hover:text-teal-400 transition-colors">
                  Residential Cleaning
                </a>
              </li>
              <li>
                <a href="#services" className="text-white/60 hover:text-teal-400 transition-colors">
                  Commercial Cleaning
                </a>
              </li>
              <li>
                <a href="#services" className="text-white/60 hover:text-teal-400 transition-colors">
                  Specialty Cleaning
                </a>
              </li>
            </ul>
          </motion.div>

          {/* Contact */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/60">
                <Phone className="w-4 h-4 text-teal-400" />
                <a href={`tel:${contactData.phone.replace(/\s/g, '')}`} className="hover:text-teal-400 transition-colors">
                  {contactData.phone}
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/60">
                <Mail className="w-4 h-4 text-teal-400" />
                <a href={`mailto:${contactData.email}`} className="hover:text-teal-400 transition-colors">
                  {contactData.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/60">
                <MapPin className="w-4 h-4 text-teal-400" />
                <span>{contactData.serviceArea}</span>
              </li>
            </ul>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 text-center text-white/40">
          <p>&copy; {currentYear} ADL Cleaning Services. All rights reserved. Proudly owned by Melinda Farrell.</p>
        </div>
      </div>
    </footer>
  );
};
